module.exports = { "default": require("core-js/library/fn/reflect/apply"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/reflect/apply.js
// module id = 66
// module chunks = 0 1